import { React, useState, useEffect, useContext } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Row, Col, Tooltip, Form, Spin } from 'antd';
import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { SelectOption } from '@iso/components/uielements/select';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentHolder from '@iso/components/utility/contentHolder';
import api from '../../../../api';
import { AppContext } from '../../../../context/ContextProvider';
import { AlertContext } from '../../../../context/alertContext';
// import awsLogo from '../../../assets/images/aws.svg';
// import customScriptIcon from '@iso/assets/images/custom-script-icon.svg';
// import secretDetectionIcon from '@iso/assets/images/secret-detection-icon.svg';
// import sonarcubeIcon from '@iso/assets/images/sonarcube-icon.svg';
// import checkmarkIcon from '@iso/assets/images/checkmark-icon.svg';
import { formatErrors, marketplaceStatuses, timeSince } from '../../../../context/helper';
import CreateTaskHeader from '../../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../../Widgets/SmallCards/SmallCards.styles';
import noDataPlusIcon from '@iso/assets/images/nodata-plus-icon.svg';
import noDataImg from '@iso/assets/images/no-data-found.svg';
import plusIcon from '@iso/assets/images/plusIcon.svg';
import Select from '@iso/containers/Deployments/Deployment.styles';
import CreateTaskFooter from '../../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';

const Option = SelectOption;

const noDataSubTitle = {
    color: "#323232",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    marginLeft: "5px"
};
let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const noDataTitle = {
    color: "#A6A6A6",
    textAlign: "center",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
};

const titleStyle = {
    color: "#7b7b7b",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: "300",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const subTitleStyle = {
    color: "#1F1F1F",
    fontFamily: "Poppins",
    fontSize: "15px",
    fontWeight: "600",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "15px"
};

let innerSubtitleStyle = {
    fontSize: "13px",
    color: "#9B9B9B",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const marginsBot = {
    position: 'fixed',
    opacity: '100%',
    transition: 'all 1s ease',
    top: "7vw",
    right: "0",
    zIndex: '1000',
    width: "25%",
    padding: '15px'
};


const widgetStyle = {
    margin: "20px",
    width: "100%",
    position: "relative",
};

export default ({
    data,
    editing,
    workflowNodeData,
    workflowEdgesData,
    // serviceId,
    columnId,
}) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const { openRightDrawer, setOpenRightDrawer, workflowData, setWorkflowData, setWorkflowNodeData, setWorkflowEdgesData, currentWorkflowData, workflowTypeExecution, setWorkflowTypeExecution, setCurrentWorkflowData, setOpenModel, infraModuleData, setInfraModuleData, checkTryWithoutLogin } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const [deployData, setDeployData] = useState(editing ? data : {
        buildType: "Automatic",
    });

    const [envDropdown, setEnvDropdown] = useState([]);
    const [fetching, setFetching] = useState(true);
    const [error, setError] = useState(null);
    const [autoTriggerOptions, setAutoTriggerOptions] = useState([]);

    // const navigate = useNavigate();
    // const location = useLocation();

    useEffect(() => {
        console.log("data in infraSourceDrawer:", data);
        console.log("deployData in infraApplyDrawer:", deployData);
        form.setFieldsValue({...deployData});
    }, []);

    const handelCancel = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    // creating Build Type options
    useEffect(() => {
        let tempAutoTriggerDropdown = [];

        ["Automatic", "Manual"].forEach((child, ind) => {
            tempAutoTriggerDropdown.push(
                <Option key={child} name="buildType" data-id="" data-region={null} value={child}>
                    <div style={{ width: "100%", display: "flex" }}>
                        <p> {child} </p>
                    </div>
                </Option>
            );
        });

        setAutoTriggerOptions(tempAutoTriggerDropdown);

        form.setFieldsValue({...deployData});
    }, []);

    useEffect(() => {
        const test = async () => {
            if (deployData.error) {
                try {
                    const values = await form.validateFields();
                    console.log('Success:', values);
                }
                catch (err) {
                    console.log("Found error :", err);
                }
            }
        }

        test();
    }, [deployData.error]);


    // const handleClick = (type) => {
    //     console.log("clicked handleClick :", type);
    //     setOpenRightDrawer({
    //         drawerType: type,
    //         drawerProps: {
    //             data: workflowData,
    //             columnId: columnId,
    //             type: "source",
    //             className: "expend",
    //         },
    //     });
    // }

    // const handelAdd = () => {
    //     let tempNodeData = [];
    //     let tempEdgesData = [];
    //     let targetIndex = 0;  // as this is sourceNode
    //     let idOrders = [];
    //     let toolsCount = 0;
    //     let sourceToolsCount = 0;
    //     let buildToolsCount = 0;
    //     let deployToolsCount = 0;

    //     console.log("workflowNodeData at beginning :", JSON.parse(JSON.stringify(workflowNodeData)));
    //     console.log("workflowEdgesData at beginning :", JSON.parse(JSON.stringify(workflowEdgesData)));
    //     console.log("currentWorkflowData at beginning :", JSON.parse(JSON.stringify(currentWorkflowData)));

    //     let workflowTempNodeData = [];
    //     // remove any build tool node if there is any previously
    //     workflowNodeData.map((item, idx) => {
    //         console.log("checking ids order list :", item);

    //         if (item.type === "sourceToolNode") {
    //             sourceToolsCount = sourceToolsCount + 1;
    //         }
    //         else if (item.type === "buildToolNode") {
    //             buildToolsCount = buildToolsCount + 1;
    //         }
    //         else if (item.type === "deployToolNode") {
    //             deployToolsCount = deployToolsCount + 1;
    //         }

    //         console.log("item.type :", item.type);
    //         console.log("item.type :", item.type !== "deployToolNode");
    //         // remove deployTool if already exist
    //         if (item.type !== "deployToolNode") {
    //             workflowTempNodeData.push(item);
    //         }
    //         else {
    //             console.log("idx :", idx);
    //             workflowEdgesData.splice(idx - 1, 1, null);
    //         }
    //     });

    //     // set temp data for workflowEdgesData
    //     let workflowTempEdgesData = workflowEdgesData.filter((temp) => temp);

    //     let deployToolStartFrom = sourceToolsCount + buildToolsCount + deployToolsCount + 3   // sourceToolsNode + buildToolsNode + deployToolsCount + (Source node + build node + deploy node)
    //     // console.log("workflowData in add new :", JSON.parse(JSON.stringify(workflowData)));
    //     // console.log("sourceToolsCount :", sourceToolsCount);
    //     // console.log("buildToolsCount :", buildToolsCount);
    //     // console.log("deployToolStartFrom :", deployToolStartFrom);
    //     // console.log("workflowTempNodeData in middle :", JSON.parse(JSON.stringify(workflowTempNodeData)));
    //     // console.log("workflowTempEdgesData in middle :", JSON.parse(JSON.stringify(workflowTempEdgesData)));

    //     currentWorkflowData.deployConfig.tools.map((temp, idx) => {
    //         console.log("workflowData.postDeployToolsData -> temp :", temp);

    //         let myNodeObj = {
    //             id: "",
    //             type: "deployToolNode",
    //             data: { label: "Deploy", id: idx + deployToolStartFrom, indx: idx, type: "deployToolNode" },
    //             position: {
    //                 x: currentWorkflowData?.fromLogsPage ? 401 : 800,
    //                 y: currentWorkflowData?.fromLogsPage ? 80 * (idx + 1) : 200 * (idx + 1)
    //             },   // 2nd node should be below first node
    //             style: { borderRadius: "20px" },
    //         }

    //         let myEdgeObj = {
    //             id: "",
    //             source: "",
    //             target: "",
    //             animated: false,
    //             // animated: false,
    //             style: { stroke: "#F7F6FA", strokeWidth: 3 },
    //         }

    //         workflowTempNodeData.splice(idx + deployToolStartFrom, 0, myNodeObj);
    //         workflowTempEdgesData.splice(idx + deployToolStartFrom, 0, myEdgeObj);
    //     });

    //     workflowTempNodeData.push({
    //         id: "",
    //         type: "deployNode",
    //         data: { label: "Deploy", toolsOrder: [0, 1, 2] },
    //         position: { x: 800, y: 50 },
    //         style: { borderRadius: "20px" },
    //         // sourcePosition: "left",
    //     });

    //     workflowTempEdgesData.push({
    //         id: "",
    //         source: (workflowTempNodeData.length - 2).toString(),
    //         target: (workflowTempNodeData.length - 1).toString(),
    //         animated: false,
    //         style: { stroke: "#ecf4fb", strokeWidth: 3 },
    //     });


    //     // position: let x, y = 0, 0;
    //     workflowTempNodeData.map((temp, idx) => {
    //         // Node
    //         // {
    //         //     id: "1",
    //         //     type: "sourceNode",
    //         //     data: { label: "Source" },
    //         //     position: { x: 0, y: 50 },
    //         //     style: { borderRadius: "20px" },
    //         //     sourcePosition: "right",
    //         //   },
    //         // let position = idx === targetIndex+1 ? { x: 0, y: 50 } : temp.position;
    //         console.log("idx :", idx);
    //         console.log("temp :", temp);

    //         workflowTempNodeData[idx] = {
    //             ...workflowTempNodeData[idx],
    //             id: `${idx + 1}`,   // should start from 1 index
    //             type: temp.type,
    //             data: temp.data,
    //             // position: { x: 450, y: 200 },
    //             position: temp.position,
    //         }

    //         // tempNodeData.push();
    //     });

    //     // For Edges
    //     workflowTempEdgesData.map((temp, idx) => {
    //         // Edge
    //         // {
    //         //     id: "e1-2",
    //         //     source: "1",
    //         //     target: "2",
    //         //     animated: false,
    //         //     style: { stroke: "#fff" },
    //         //   },

    //         // source will always remain at it's position
    //         if (idx != 0) {
    //             workflowTempEdgesData[idx] = {
    //                 ...workflowTempEdgesData[idx],
    //                 id: `e${idx + 1}-${idx + 2}`,
    //                 source: `${idx + 1}`,
    //                 target: `${idx + 2}`,
    //             }
    //         }

    //         // tempEdgesData.push();
    //     });

    //     console.log("workflowTempNodeData :", workflowTempNodeData);
    //     console.log("workflowTempEdgesData :", workflowTempEdgesData);

    //     let filteredEdgeData = workflowTempEdgesData.filter((item, idx) => item.source && parseInt(item.source) < workflowTempNodeData.length)
    //     console.log("filteredEdgeData :", filteredEdgeData);

    //     setWorkflowNodeData([...workflowTempNodeData]);
    //     setWorkflowEdgesData([...filteredEdgeData]);
    //     // we can't perform below because it will impact build tool add
    //     // setWorkflowTypeExecution({
    //     //     source: true,
    //     //     build: false,
    //     //     deploy: currentWorkflowData.withoutCI ? true : false
    //     // });
    // }

    const saveEnvChanges = () => {
        console.log("inside saveEnvChanges...");

        setDeployData({ ...deployData, error: null });
        form.setFieldsValue({...deployData, error: null});

        setInfraModuleData((prev) => {
            return {
                ...prev,
                workflowBuilder: {
                    ...prev.workflowBuilder,
                    applyConfig: {
                        ...prev.workflowBuilder.applyConfig,
                        config: deployData,
                    },
                }
            }
        });

        localStorage.setItem("InfraModule", JSON.stringify({
            ...infraModuleData,
            workflowBuilder: {
                ...infraModuleData.workflowBuilder,
                applyConfig: {
                    ...infraModuleData.workflowBuilder.applyConfig,
                    config: deployData,
                },
            }
        }));

        handelCancel();

        setOpenModel({
            modalType: false,
            modalProps: {
                data: null,
            },
        });
    }

    const handleSaveDetails = async (e) => {
        console.log("clicked handleSaveDetails...",);
        try {
            const values = await form.validateFields();
            console.log('Success:', values);
            saveEnvChanges();
        }
        catch (err) {
            console.log("Found error :", err);
            if (err.errorFields[0].errors[0] === deployData.error) {
                // "CONFIRM_ACTION"
                setOpenModel({
                    modalType: 'CONFIRM_ACTION',
                    modalProps: {
                        data: "",
                        title: "Save Workflow?",
                        subTitle: <span style={{ display: "block" }}>
                            <p>Are you sure you want to save this environment?</p>
                            {deployData.error && <p style={{ color: "#CB444A", fontSize: "12px", marginTop: "15px" }}> Note: {deployData.error}</p>}
                        </span>,
                        cancelButton: "Cancel",
                        saveButton: "Save",
                        onConfirm: () => { console.log("onConfirm"); saveEnvChanges() },
                        onCancel: () => { console.log("onCancel") },
                        columnId: null,
                        className: "large-Box"
                    },
                });
            }
        }
    }

    const handleSelectChange = (value, event) => {
        console.log("clicked handleSelectChange...");
        if (event.name === "env-redirect") {
            navigate(`/environments/create`, {
                state: {
                    data: null,
                    from: "workflow-deploy"
                }
            });
        }
        else if (event.name === "buildType") {
            setDeployData({ ...deployData, buildType: value });
            form.setFieldsValue({...deployData, buildType: value});
        }
        else {
            setDeployData({ ...deployData, envName: value, envId: event["data-id"], error: null });
            form.setFieldsValue({...deployData, envName: value, envId: event["data-id"], error: null});
        }
    }

    const handleCancel = (e) => {
        console.log("clicked handleCancel...");
        handelCancel();
    }


    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={columnId} onCancel={handelCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />

            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <Form
                    form={form}
                    initialValues={{ ...deployData }}
                    preserve={false}
                    name="dynamic_rule"
                    style={{
                        width: "100%",
                        height: "fit-content"
                    }}
                >
                    <Box
                        title={`Apply Type${currentWorkflowData?.fromLogsPage ? "" : "*"}`}
                        subtitle={"Select apply type from the following."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", marginBottom: "150px" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="buildType"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide apply type.',
                                    },
                                ]}
                            >
                                <Select
                                    value={deployData?.buildType ? deployData.buildType : undefined}
                                    placeholder="Select"
                                    onChange={handleSelectChange}
                                    style={{ width: "100%" }}
                                    disabled={infraModuleData?.fromLogsPage || checkTryWithoutLogin}
                                >
                                    {autoTriggerOptions}
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                </Form>
            </StickerWidgetWrapper>

            {!(infraModuleData?.fromLogsPage || checkTryWithoutLogin) && <CreateTaskFooter buttonContent={"Source Config"} givenButtonFunction1={handleSaveDetails} givenButtonFunction2={handleCancel} />}
        </LayoutWrapper>
    );
};